export const WORKFORCE_DASHBOARD_SCROLLABLE_SECTION_MAX_HEIGHT = 320;

export const WORKFORCE_DASHBOARD_ALIGNMENT_SHAPE_CHART_HEIGHT = 400;

export const WORKFORCE_DASHBOARD_OVERVIEW_GRID_SX = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: {xs: '1fr', md: '1fr 1fr 2fr'},
  alignItems: 'stretch',
} as const;

/** Content min height for recurring skill gaps (5 rows + CTA) — paired row baseline. */
export const WORKFORCE_DASHBOARD_PAIRED_SECTION_CONTENT_MIN_HEIGHT = 176;
